module.exports = __webpack_public_path__ + "img/AsylumVol1.c0efd904.jpeg";